<template>
  <div>
    <CRow>
      <CCol sm="12" md="12" lg="6">
        <CCard accent-color="primary">
          <CCardHeader class="font-weight-bold catalogo-text">Reportes</CCardHeader>
          <CCardBody>
            <CDataTable hover small :items="categories" :fields="fieldsReportes" pagination>
              <template #categoria="{item, index}">
                <!-- @click="toggleSelect(index, item)" -->

                <td @click="toggleLote(index)" class="py-2 table">
                  <span>
                    <CIcon
                      v-if="getReports(item.categoria).length"
                      name="cil-chevron-circle-down-alt"
                    />
                  </span>
                  {{ item.categoria }}
                </td>
              </template>
              <template #details="{item, index}">
                <CCollapse :show="details.includes(index)">
                  <CCardBody class="py-0 pl-2 pr-0">
                    <table class="custom-width-total mb-0">
                      <tbody>
                        <!-- <div
                          v-for="(rep, index) in getReports(item.categoria)"

                          :key="index"
                        >-->
                        <tr
                          v-for="(rep, index) in getReports(item.categoria)"
                          :key="index"
                          class="detail"
                          @click="toggleSelect(index, rep)"
                        >
                          <td class="custom-width-total">
                            <p class="mb-1 font-weight-bold">{{ rep.titulo }}</p>
                            <p class="mb-1 font-xs">{{ rep.descripcion }}</p>
                          </td>
                          <!-- <td class="table"></td> -->
                        </tr>
                        <!-- </div> -->
                      </tbody>
                    </table>
                  </CCardBody>
                </CCollapse>
              </template>
            </CDataTable>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol sm="12" md="12" lg="6">
        <CCard v-show="itemReport.nombre" accent-color="primary">
          <CCardHeader class="font-weight-bold catalogo-text">{{ itemReport.nombre }}</CCardHeader>
          <CCardBody>
            <div>
              <CRow v-for="(item, index) in filters" :key="index">
                <CCol class="mb-1" md="9" lg="9" v-if="item.tipo == `periodo`">
                  <p class="mb-2">{{ item.etiqueta }}:</p>
                  <DateSelector class="z-custom-2" v-model="selectedDate" />
                </CCol>
                <CCol md="9" lg="9" v-if="(item.tipo == `select` || item.tipo == `select_multiple`) && item.etiqueta == `Cultivo`">
                  <label>{{item.required?'* ':''}}{{ item.etiqueta }}:</label>
                  <v-select
                    v-model="conf_cultivo"
                    :multiple="item.tipo == `select_multiple`"
                    :options="mostrarItems(item)"
                    :loading="isLoadingPage"
                    class="margin-multi"
                    :placeholder="item.etiqueta"
                  >
                    <template #open-indicator="{ attributes }">
                      <CIcon v-bind="attributes" style="cursor:pointer" name="cil-caret-bottom" />
                    </template>
                    <template #no-options>
                      Sin resultados.
                    </template>
                  </v-select>
                </CCol>
                <CCol md="9" lg="9" v-else-if="item.tipo == `select` || item.tipo == `select_multiple`">
                  <label>{{ item.etiqueta }}:</label>
                  <v-select
                    v-model="item.value"
                    :multiple="item.tipo == `select_multiple`"
                    :options="item.items"
                    :loading="isLoadingPage"
                    class="margin-multi"
                    :placeholder="item.etiqueta"
                  >
                    <template #open-indicator="{ attributes }">
                      <CIcon v-bind="attributes" style="cursor:pointer" name="cil-caret-bottom" />
                    </template>
                    <template #no-options>Sin resultados.</template>
                  </v-select>
                </CCol>
                <CCol md="9" lg="9" v-if="(item.tipo == `select` || item.tipo == `select_multiple`) && item.etiqueta == `Cultivo`">
                  <label>{{item.required?'* ':''}}Variedad</label>
                  <v-select
                    v-model="item.value"
                    :multiple="item.tipo == `select_multiple`"
                    :options="mostrarVariedad()"
                    :loading="isLoadingPage"
                    class="margin-multi"
                    :placeholder="'Variedad'"
                  >
                    <template #open-indicator="{ attributes }">
                      <CIcon v-bind="attributes" style="cursor:pointer" name="cil-caret-bottom" />
                    </template>
                    <template #no-options>
                      Sin resultados.
                    </template>
                  </v-select>
                </CCol>
                <CCol md="9" lg="9" v-if="(item.tipo == `select` || item.tipo == `select_multiple`) && item.etiqueta == `Cultivo` && item.embalaje != false">
                  <label>{{item.required?'* ':''}}Embalaje</label>
                  <v-select
                    v-model="embalaje"
                    :multiple="true"
                    :options="mostrarEmbalaje()"
                    :loading="isLoadingPage"
                    :closeOnSelect="false"
                    class="margin-multi"
                    :placeholder="'Embalaje'"
                  >
                    <template #open-indicator="{ attributes }">
                      <CIcon v-bind="attributes" style="cursor:pointer" name="cil-caret-bottom" />
                    </template>
                    <template #no-options>
                      Sin resultados.
                    </template>
                  </v-select>
                </CCol>
                <CCol md="9" lg="9" v-if="item.tipo == `select_local`">
                  <label>{{ item.etiqueta }}:</label>
                  <v-select
                    v-model="item.value"
                    :options="item.items"
                    :loading="isLoadingPage"
                    class="margin-multi"
                    :placeholder="item.etiqueta"
                  >
                    <template #open-indicator="{ attributes }">
                      <CIcon v-bind="attributes" style="cursor:pointer" name="cil-caret-bottom" />
                    </template>
                    <template #no-options>Sin resultados.</template>
                  </v-select>
                </CCol>
                <CCol md="9" lg="9" v-if="item.tipo == `text`">
                  <label>{{ item.etiqueta }}:</label>
                  <CInput v-model="item.value" :placeholder="item.etiqueta"/>
                </CCol>
              </CRow>
            </div>

            <CRow class="mt-3">
              <CCol md="12" lg="12">
                <CButton @click="getReport()" class="btn-custom-width" color="primary">
                  <div v-if="isLoading">
                    <div class="w-100 d-flex justify-content-center align-items-center">
                      <div class="sk-flow height-custom flex align-items-center">
                        <div class="sk-flow-dot bg-load-white"></div>
                        <div class="sk-flow-dot bg-load-white"></div>
                        <div class="sk-flow-dot bg-load-white"></div>
                      </div>
                    </div>
                  </div>
                  <span v-else>Generar</span>
                </CButton>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <CModal
      size="sm"
      title="Reportes"
      :centered="true"
      color="warning"
      :show.sync="warningModal"
    >{{ error }}</CModal>
    <CModal
      size="sm"
      title="Reportes"
      :centered="true"
      color="warning"
      :show.sync="warningModalUbicacion"
      >Selecciona la ubicación para generar el reporte</CModal
    >
  </div>
</template>

<script>
// import { setupCalendar, DatePicker } from "v-calendar";
import moment from "moment";
// import "v-calendar/lib/v-calendar.min.css";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import DateSelector from "../../../customComponents/DateSelector";
import ReportRootScopedFilters from "../../../mixins/ReportRootScopedFilters";
import { template } from "@babel/core";
//import DateSelector from "../customComponents/DateSelector";

// setupCalendar({
//   firstDayOfWeek: 2 // Monday
// });

const today = new Date();

const fieldsReportes = [
  { key: "categoria", label: "Nombre", _style: "width:100%" }
];


export default {
  name: "ReportsPage",
  components: {
    // "v-date-picker": DatePicker,
    vSelect,
    DateSelector
  },
  mixins: [ReportRootScopedFilters],
  data() {
    return {
      itemsReportes: [],
      fieldsReportes,

      collapse: false,
      details: [],
      categories: [],
      joker: [],
      warningModal: false,
      warningModalUbicacion: false,
      error: "",
      filters: [],
      isLoading: false,
      isLoadingPage: false,
      itemReport: {
        id: "",
        nombre: "",
        reporte: "",
        params: null
      },
      selectedDate: {
        // start: new Date(today.getFullYear(), today.getMonth(), 1),
        // start: new Date(2019, 1, 1),
        // end: new Date(today.getFullYear(), today.getMonth() + 1, 0)
        // end: new Date(2020, 2, 11)
      },
      cultivos: [],
      cat_cultivo: [],
      conf_cultivo: null,
      embalaje: [],
      conf_embalajes: []
    };
  },

  created() {
    this.isLoadingPage = true;
    const categoriesId = [];
    this.$store
      .dispatch("getReportsPdf", {
        filter:{
          where:[
            {
              filed: 'categoria',
              operator: '=',
              value: "Formatos"
            }
          ]
        }
      })
      .then(res => {
        // console.log(res);
        // const

        this.categories = res.data
          .map(report => {

            if (!categoriesId.includes(report.categoria) && report && report.categoria!='Formatos') {
              // console.log(report);

              categoriesId.push(report.categoria);
              return { categoria: report.categoria };
            } else {
              return { categoria: "" };
            }
          })
          .filter(cat => (cat.categoria ? true : false)).sort((a,b)=>a.categoria.localeCompare(b.categoria));
        this.itemsReportes = res.data;
        // console.log(categoriesId);

        // console.log(this.itemsReportes);
        //
      })
      .finally(() => (this.isLoadingPage = false));
  },

  computed: {
    rangeStart() {
      return new Date(this.selectedDate.start).toLocaleDateString();
    },
    rangeEnd() {
      return new Date(this.selectedDate.end).toLocaleDateString();
    },
    clave_empresa() {
      return this.$store.state.clave_empresa.toUpperCase();
    },
    ubicacionRaiz() {
      return this.$store.state.rootLocation ? this.$store.state.rootLocation.value : "";
    }
  },

  watch: {
    ubicacionRaiz: function() {
      this.filters = this.clearReportFiltersExceptPeriod(this.filters);
      this.getDataFilter();
    }
  },

  methods: {
    mostrarVariedad() {
      if (this.conf_cultivo != null) {
        return this.cat_cultivo.filter(element =>
        element.cultivo.normalize("NFD").replace(/[\u0300-\u036f]/g, "") == this.conf_cultivo.label.normalize("NFD").replace(/[\u0300-\u036f]/g, ""));
      }else{
        return this.cat_cultivo
      }
    },
    mostrarEmbalaje() {
      if (this.conf_embalajes.length > 0) {
        if (this.conf_cultivo != null) {
          let embalajes = this.conf_embalajes.filter(element =>
          element.cultivo.normalize("NFD").replace(/[\u0300-\u036f]/g, "") == this.conf_cultivo.label.normalize("NFD").replace(/[\u0300-\u036f]/g, ""));
          return embalajes[0].embalajes
        }else{
          return this.conf_embalajes[0].embalajes
        }
      }
    },
    mostrarItems(item){
      if (item.etiqueta == 'Cultivo') {
        return this.cultivos
      }else{
        return item.items
      }
    },
    toggleLote(index) {
      const position = this.details.indexOf(index);
      position !== -1
        ? this.details.splice(position, 1)
        : this.details.push(index);
    },
    toggleSelect(index, item) {
      this.embalaje = []
      this.conf_cultivo = null
      this.itemReport.id = index;
      this.itemReport.nombre = item.titulo;
      this.itemReport.reporte = item.nombre;
      this.itemReport.params = item.params;
      // this.getSelectedfilters(item.params);
      this.filters = item.params.map(item => {

        if (item.tipo == "select") {
          // this.getDataFilter(item);

          // console.log(this.getDataFilter(item).then(res => (x = res)));

          return { ...item, value: null, items: [] };
        } else if (item.tipo == "select_local") {
          const values = item.config.data.map(i => {
            return { value: i.valor, label: i.etiqueta };
          });
          return { ...item, value: null, items: values };
        } else if (item.tipo == "periodo") {
          return {
            ...item,
            selectedDate: {
              start: new Date(today.getFullYear(), today.getMonth(), 1),
              end: new Date(today.getFullYear(), today.getMonth() + 1, 0)
            }
          };
        } else {
          return item;
        }
      });

      this.getDataFilter();

      // console.log(newFilters);
    },
    getSelectedfilters(filters) {

      let values = [];
      this.filters = filters.map(async fil => {
        if (fil.tipo == "select") {
          if (fil) {
            if (fil.config.type == "cat") {
              template = { schema: fil.config.schema };
              // console.log(fil);
              // console.log(template);

              await this.$store
                .dispatch("customHTTP", template)
                .then(res => {
                  // console.log(res.data);
                  values = res.data.map(item => {
                    return {
                      value: this.setKey(`${fil.config.valor}`, item),
                      label: this.setKey(`${fil.config.etiqueta}`, item)
                    };
                  });
                  // return values;
                });
            }
          }
          // console.log(this.getDataFilter(item).then(res => (x = res)));

          return { ...fil, value: null, items: values };
        } else if (fil.tipo == "periodo") {
          return {
            ...fil,
            selectedDate: {
              start: new Date(today.getFullYear(), today.getMonth(), 1),
              end: new Date(today.getFullYear(), today.getMonth() + 1, 0)
            }
          };
        } else {
          return fil;
        }
      });
    },

    getDataFilter() {

      this.isLoadingPage = true;
      let values = [];

      this.filters.map((fil, index) => {
        if (fil && fil.tipo == "select") {
          fil.config.type == "cat";
          let catalogo = {
            schema: fil.config.schema
          };

          "filtro" in fil.config
            ? (catalogo = { ...catalogo, filter: { ...fil.config.filtro } })
            : "";

          if (fil.config.schema == "trabajadores") {
            catalogo = {
              ...catalogo,
              filter: {
                ...catalogo?.filter||{},
                where: [
                  ...catalogo.filter?.where||[],
                  {
                    field: "payload->ubicaciones",
                    operator: "regexp",
                    value: `[[:<:]]${this.ubicacionRaiz}[[:>:]]`
                  },
                  {
                    field: "payload->suspendido",
                    operator: "=",
                    value: false
                  }
                ]
              }
            };
          }

          if (fil.config.schema == "almacenes" ) {
            catalogo = {
              ...catalogo,
              filter: {
                ...catalogo?.filter||{},
                wherein: [
                  ...catalogo?.filter?.wherein||[],
                  {
                    field: "payload->ubicacion_id",
                    operator: "=",
                    value: [this.ubicacionRaiz]
                  },
                ]
              }
            };
          }

          this.$store
            .dispatch("customHTTP", catalogo)
            .then(res => {
              values = res.data.map(item => {
                return {
                  value: this.setKey(`${fil.config.valor}`, item),
                  label: this.setKey(`${fil.config.etiqueta}`, item)
                };
              });
              this.filters[index].items = values;

              this.$store.dispatch("customHTTP", {
                schema: "configuracion",
                filter:{
                  where: [
                    {
                      field: "payload->parametro",
                      value: "cultivos",
                      operator: "="
                    }
                  ]
                }
              }).then(response => { //Variedad
                if (catalogo.schema == 'cultivos') {
                  this.cultivos = []
                  this.conf_embalajes = []
                  let cultivo = response.data[0].payload.valor
                  for (let index = 0; index < cultivo.length; index++) {
                    let i = 1
                    const element = cultivo[index];
                    this.cultivos.push({value: index+1, label: element.nombre})
                    let emb = element.embalajes.map(item=>{
                      return { value: i++, label: item }
                    })
                    this.conf_embalajes.push({ cultivo : element.nombre, embalajes: emb})
                  }
                  this.cat_cultivo = res.data.map(item => {
                    return {value: item.id, cultivo: item.payload.nombre.split(' ')[0], label: item.payload.variedad ? item.payload.variedad :  ((item.payload.nombre).split(' ').slice(1).join(' ')) }
                  })
                }
              })

            })
            .finally(() => (this.isLoadingPage = false));
        }
      });
    },
    setKey(key, targetObject) {
      var keys = key.split("."),
        obj = targetObject || window,
        keyPart;
      while ((keyPart = keys.shift()) && keys.length) {
        obj = obj[keyPart];
      }
      return obj[keyPart];
    },
    toggleMonth() {
      this.selectedDate.start = new Date(
        today.getFullYear(),
        today.getMonth(),
        1
      );
      this.selectedDate.end = new Date(
        today.getFullYear(),
        today.getMonth() + 1,
        0
      );
    },
    toggleLastMonth() {
      this.selectedDate.start = new Date(
        today.getFullYear(),
        today.getMonth() - 1,
        1
      );
      this.selectedDate.end = new Date(
        today.getFullYear(),
        today.getMonth(),
        0
      );
    },
    getReports(category) {
      return this.itemsReportes.filter(report => report.categoria == category).sort((a,b)=>a.titulo.localeCompare(b.titulo));
    },
    toggleYear() {
      this.selectedDate.start = new Date(today.getFullYear(), 0, 1);
      this.selectedDate.end = new Date(today.getFullYear(), 11, 31);
    },
    getValue(name, type) {
      if (name) {
        if (type == "periodo") {
          return [
            moment(this.selectedDate.start).format("YYYY-MM-DD"),
            moment(this.selectedDate.end).format("YYYY-MM-DD")
          ];
        } else if (type == "text") {
          const value = this.filters.find(i => i.nombre == name);
          return value.value;
        } else {
          const value = this.filters.find(i => i.nombre == name);
          return value ? (value.value ? (Array.isArray(value.value) ? value.value.map(item => item.value) : value.value.value) : null) : null;
        }
      }
      return;
    },
    getReport() {
      this.isLoading = true;
      let call = [];
      // if (this.itemReport.reporte !== "costos") {
      // let dateStart = this.selectedDate.start;
      // let dateEnd = this.selectedDate.end;

      // dateStart.setHours(0, 0, 0);
      // dateEnd.setHours(23, 59, 59);
      // // }
      // console.log(dateStart);
      // console.log(dateEnd);

      if (this.ubicacionRaiz == "") {
        this.warningModalUbicacion = true
        this.isLoading = false;
        return;
      }

      if( !this.itemReport.params.every(e=>!e.required||this.getValue(e.nombre, e.tipo))){
        const valores = this.itemReport.params.filter(ff=>{
          return ff.required && [null,undefined].includes(this.getValue(ff.nombre, ff.tipo))
        }).map(m => m.etiqueta)
        this.error = `Son requeridos los campos: ${valores.join(', ')}`;
        this.warningModal = true;
        this.isLoading = false;
        return
      }

      const reportParams = this.itemReport.params.map(p => {
        // console.log(p);
        return { [p.nombre]: this.getValue(p.nombre, p.tipo) };
      });

      // console.log(reportParams);

      const obj = {};
      reportParams.forEach(currentValue => {
        var key = Object.keys(currentValue)[0]; //take the first key from every object in the array
        obj[key] = currentValue[key];
      });

      if (this.conf_cultivo != null) {
        obj['cultivo'] = this.conf_cultivo.label.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
      }
      // if (this.embalaje.length > 0) {
        let emb = []
        for (let index = 0; index < this.embalaje.length; index++) {
          const element = this.embalaje[index];
          emb.push(element.label.normalize("NFD").replace(/[\u0300-\u036f]/g, ""))
        }
        obj['embalaje'] = emb
      // }
      // let object = Object.assign({}, ...reportParams);

      // console.log(obj);

      const reportCall = {
        reporte: this.itemReport.reporte,
        params: { ...obj, ubicaciones: [this.ubicacionRaiz]},
        pdf : true
      };

      // console.log(reportCall);
      // call.push(reportCall);

      call.push(
        this.$store.dispatch("reportsPDFHttp", {
          ...reportCall
        })
      );
      // } else {
      // let dateStart = this.selectedDate.start;
      // let dateEnd = this.selectedDate.end;
      // dateStart.setHours(0, 0, 0);
      // dateEnd.setHours(23, 59, 59);

      // console.log({
      //   reporte: this.itemReport.reporte,
      //   filtro: {
      //     RUTA_MODULO: `${this.clave_empresa}:C4.BALANCE_FINANCIERO.COSTO`,
      //     FECHA: {
      //       WHERE: {
      //         OPERATOR: "BETWEEN",
      //         VALUE: [
      //           moment(this.selectedDate.start).format("YYYY-MM-DDTHH:mm:ss"),
      //           moment(this.selectedDate.end).format("YYYY-MM-DDTHH:mm:ss")
      //         ]
      //       }
      //     }
      //   }
      // });

      // call.push(
      //   this.$store.dispatch("reportsHTTP", {
      //     reporte: this.itemReport.reporte,
      //     filtro: {
      //       RUTA_MODULO: `${this.clave_empresa}:C4.BALANCE_FINANCIERO.COSTO`,
      //       FECHA: {
      //         WHERE: {
      //           OPERATOR: "BETWEEN",
      //           VALUE: [
      //             moment(this.selectedDate.start).format(
      //               "YYYY-MM-DDTHH:mm:ss"
      //             ),
      //             moment(this.selectedDate.end).format("YYYY-MM-DDTHH:mm:ss")
      //           ]
      //         }
      //       }
      //     }
      //   })
      // );
      // }

      Promise.all(call)
        .then(res => {

          const [blob] = res;

          let a = document.createElement("a");
          a.style = "display: none";
          const url = window.URL.createObjectURL(blob);
          a.href = url;
          a.download = this.itemReport.nombre + '.pdf';
          a.click();
          window.URL.revokeObjectURL(url);
        })
        .catch(rej => {
          // console.log(rej);
          this.error = rej.message;
          this.warningModal = true;
        })

        .finally(() => {
          this.isLoading = false;
        });

      // this.isLoading = false;
    }
  }
};
</script>

<style src="spinkit/spinkit.min.css"></style>

<style scoped>
.z-custom-2 {
  z-index: 4;
}
.catalogo-text {
  font-size: 1.2rem !important;
}
.table {
  cursor: pointer;
}
.table:hover {
  color: white;
  background-color: #321fdb;
}
.detail {
  width: 100%;
  cursor: pointer;
}
.detail:hover {
  color: white;
  background-color: #321fdb;
}
.tr:hover {
  color: white;
}
.custom-width-btn {
  width: 40%;
}
.custom-heigth-btn {
  width: 10%;
}
.custom-font-size {
  font-size: 1rem;
}
.custom-width {
  width: 100%;
}
.custom-width5 {
  width: 10% !important;
}
.custom-width-total {
  width: 100% !important;
}
.bg-load-white {
  background-color: white !important;
}
.height-custom {
  height: 20px;
}
@media (max-width: 420px) {
  .btn-header {
    padding-left: 6px;
    padding-right: 6px;
    font-size: 11px;
  }
  .padding-sm {
    padding-left: 10px;
    padding-right: 10px;
  }
  .text-sm {
    font-size: 11px !important;
  }
  .margin-sm {
    margin: 5px;
  }
}
</style>
